import { Container } from '@mui/material';
import EventList from './EventsList';
import { Outlet, useParams } from 'react-router-dom';

function EventsTab () {
  const { id } = useParams();

  return <Container>{id ? <Outlet /> : <EventList />}</Container>;
}

export default EventsTab;
